;(() => {
  const EMAIL_REGEX = /\S+@\S+\.\S+/

  function initOrderStatusForm() {
    const emailField = document.querySelector(
      '.order-status-box input[type="email"]',
    )
    const submitButton = document.querySelector(
      '.order-status-box button[type="submit"]',
    )

    if (!emailField) {
      return
    }

    const setSubmitButtonStatus = () => {
      const isValid = emailField.value.match(EMAIL_REGEX) !== null

      submitButton.disabled = !isValid
    }

    emailField.addEventListener("keyup", () => {
      setSubmitButtonStatus()
    })
  }

  window.addEventListener("DOMContentLoaded", () => {
    initOrderStatusForm()
  })
})()
